const enableHeadtrixxNativeCartFlow = (root = document) => {
  root.querySelectorAll?.('add-to-cart-component').forEach((component) => {
    component.setAttribute('data-add-to-cart-animation', 'true');
  });

  document.querySelector('cart-drawer-component')?.setAttribute('auto-open', '');
};

class HeadtrixxCardBuy extends HTMLElement {
  connectedCallback() {
    enableHeadtrixxNativeCartFlow(this);
  }
}

if (!customElements.get('headtrixx-card-buy')) {
  customElements.define('headtrixx-card-buy', HeadtrixxCardBuy);
}

const initializeHeadtrixxBestsellers = () => {
  enableHeadtrixxNativeCartFlow(
    document.querySelector(".shopify-section[id*='bestsellers_product_list']") || document
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHeadtrixxBestsellers, { once: true });
} else {
  initializeHeadtrixxBestsellers();
}

document.addEventListener('shopify:section:load', initializeHeadtrixxBestsellers);
